// マスタメンテ用のenumを定義
export enum Mode {
  'none',
  'postMode',
  'putMode',
  'copyMode',
  'importCsvMode',
}

export enum Cases {
  'none',
  'changeSachForms',
  'changePostMode',
  'changeClearMode',
  'changeEditingData',
  'searchData',
  'clearDtlForms',
  'reset',
}

/** Nullチェック時に期待する型 */
export type CheckNullExpectType = 'string' | 'number' | 'boolean';
export namespace CheckNullExpectType {
  export const string: CheckNullExpectType = 'string';
  export const number: CheckNullExpectType = 'number';
  export const boolean: CheckNullExpectType = 'boolean';
}
